import React from 'react'
import Modal from 'components/Modal/Modal'
import Table from './Table'
import GptPromptForm from './GptPromptForm'

const GptPrompts = () => (
  <Modal.Provider>
    <Table />
    <Modal title="Edit GPT Prompt" id="gptPromptForm" width={800}>
      <GptPromptForm />
    </Modal>
  </Modal.Provider>
)

export default GptPrompts
